import { datalabHttp, type TDatalabHttpConfig } from '@dbl/services/common';
import type { IColumnOptionRequest } from '@dbl/services/filter';

/**
 * 遗留：拉取字段下拉选项（`getDimensionInfo`）。
 *
 * 主链路已改用 `services/filter/getReportDimensionInfo`；本接口仅服务于
 * 号码包提取、探索性分析等边缘场景，后续计划删除。
 *
 * 原始目录：`services/string/` -> getColunmOptions
 */
export function getColunmOptions(
  params: IColumnOptionRequest,
): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/getDimensionInfo',
    method: 'post',
    data: params,
    ignoreRequestId: true,
  } as TDatalabHttpConfig);
}
